// Theme ids, without names or word lists: names are translated in web/strings.ts and the
// lists live server-side in src/wordlists/. The order is fixed (seeds draw from it); pickers
// sort by the translated name.

export const THEME_IDS = [
  "animals",
  "weather",
  "colors",
  "body",
  "sports",
  "school",
  "fruits",
  "home",
  "music",
  "nature",
  "countries",
  "jobs",
  "coding",
  "clothes",
  "tech",
  "transport",
] as const;

export type ThemeId = (typeof THEME_IDS)[number];

/** Lets the server pick: any theme at creation, a different one on rematch. */
export const RANDOM_THEME = "random";
export type ThemeChoice = ThemeId | typeof RANDOM_THEME;

const THEME_ID_SET: ReadonlySet<string> = new Set(THEME_IDS);

export function isThemeId(value: unknown): value is ThemeId {
  return typeof value === "string" && THEME_ID_SET.has(value);
}

export function isThemeChoice(value: unknown): value is ThemeChoice {
  return value === RANDOM_THEME || isThemeId(value);
}
